export enum FamilyStructure {
  SINGLE = 'Single',
  COUPLE = 'Couple',
  FAMILY = 'Family',
}

export const iconDimensions = {
  Single: { width: 34, height: 45 },
  Couple: { width: 57, height: 69 },
  Family: { width: 73, height: 69 },
};
